import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Loader } from "@/components/common";

const CH = [["app", "Application"], ["push", "Push"], ["email", "E-mail"]];

export function NotificationPrefs() {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState(null);
  const load = () => api.get("/me/notification-prefs").then(({ data }) => setD(data));
  useEffect(() => {
    load();
    api.get("/me/messaging-prefs").then(({ data }) => setMsg(data));
  }, []);
  if (!d || !msg) return <Loader />;
  const isOff = (k, c) => (d.off[k] || []).includes(c);
  const toggle = (k, c) => {
    const cur = d.off[k] || [];
    setD({ ...d, off: { ...d.off, [k]: cur.includes(c) ? cur.filter((x) => x !== c) : [...cur, c] } });
  };
  const save = async () => {
    try {
      await api.put("/me/notification-prefs", { off: d.off, quiet_hours: d.quiet_hours });
      toast.success("Préférences enregistrées");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const saveMsg = async (next) => {
    setMsg(next);
    await api.put("/me/messaging-prefs", next).then(() => toast.success("Confidentialité mise à jour")).catch((e) => toast.error(errMsg(e)));
  };
  return (
    <div className="space-y-6" data-testid="notification-prefs">
      <div className="mr-card p-4 space-y-3">
        <p className="font-medium">Messagerie</p>
        {[["read_receipts", "Confirmations de lecture"], ["show_presence", "Afficher « en ligne » et « vu à »"]].map(([k, l]) => (
          <label key={k} className="flex items-center justify-between text-sm min-h-[40px]">{l}
            <input type="checkbox" data-testid={`msg-pref-${k}`} className="w-5 h-5" checked={msg[k]} onChange={(e) => saveMsg({ ...msg, [k]: e.target.checked })} /></label>
        ))}
        <p className="text-xs text-mr-muted">Si vous les désactivez, vous ne voyez plus non plus celles des autres.</p>
      </div>
      <div className="mr-card p-4">
        <p className="font-medium mb-3">Canaux par catégorie</p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-mr-muted"><th className="py-2 pr-2">Catégorie</th>{CH.map(([c, l]) => <th key={c} className="px-2 text-center">{l}</th>)}</tr></thead>
            <tbody>
              {d.categories.map((cat) => (
                <tr key={cat.key} className="border-t border-mr-border" data-testid={`pref-row-${cat.key}`}>
                  <td className="py-2 pr-2">{cat.label}{cat.locked && <span className="block text-[11px] text-mr-muted">Toujours actif (sécurité / paiement)</span>}</td>
                  {CH.map(([c]) => {
                    const v = cat.channels[c];
                    if (!v) return <td key={c} className="text-center text-mr-muted">—</td>;
                    if (v === "hebdo") return <td key={c} className="text-center text-xs text-mr-muted">résumé hebdo</td>;
                    return <td key={c} className="text-center"><input type="checkbox" data-testid={`pref-${cat.key}-${c}`} className="w-4 h-4" disabled={cat.locked} checked={cat.locked || !isOff(cat.key, c)} onChange={() => toggle(cat.key, c)} /></td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <label className="block mt-4 text-sm">Heures calmes (pas de push) — format 22:00-07:00, vide = valeur du club ({d.default_quiet_hours || "aucune"})
          <input data-testid="quiet-hours-input" className="mr-input mt-1 tabular" placeholder="22:00-07:00" value={d.quiet_hours} onChange={(e) => setD({ ...d, quiet_hours: e.target.value })} /></label>
        <button data-testid="notification-prefs-save" className="mr-btn-primary w-full mt-4" onClick={save}>Enregistrer</button>
      </div>
    </div>
  );
}
